module.exports = __webpack_public_path__ + "media/images/athletes/1578-c805d2f3ad6b7fa0d6ab56b1547324a5.png";